const POLL_COLUMNS = [
  {
    name: "title",
    id: "title",
    label: "Title",
    width: 260,
    widget: "text",
    fixed: 'left'
  },
  // {
  //   name: "answerOptions",
  //   id: "answerOptions",
  //   label: "Poll Options",
  //   width: 250,
  //   widget: "pollOptions"
  // },
  {
    name: "description",
    id: "description",
    label: "Description",
    widget: "text"
  },
  {
    name: "pollType",
    id: "pollType",
    label: "Type"
  },
  {
    name: "status",
    id: "status",
    label: "Status",
    width: 140,
    widget: "status"
  },
  {
    name: "startDate",
    id: "startDate",
    label: "Start Date",
    width: 160,
    widget: "date"
  },
  {
    name: "endDate",
    id: "endDate",
    label: "Expires On",
    width: 160,
    widget: "date"
  }
];


export {POLL_COLUMNS};